import React from "react";

export const perfilLabels = {
  AUDITOR: "Auditor",
  GERENTE: "Gerente",
  ENCARREGADO: "Encarregado",
  VISITANTE: "Visitante",
};

const perfis = Object.keys(perfilLabels);

const radioStyle = {
  width: "20px",
  height: "20px",
  accentColor: "#2b97be", // cor customizada, opcional
  marginRight: "0.5rem"
};

const PerfilRadioGroup = ({ register, watch, required }) => (
  <div className="border rounded p-3 bg-light">
    <h2>Tipo de Permissão do Usuário</h2>
    {perfis.map((perfil) => (
      <div key={perfil} className="mt-2">
        <label style={{ display: "flex", alignItems: "center", gap: "0.7rem" }}>
          <input
            type="radio"
            value={perfil}
            {...register("perfil", { required })}
            checked={watch("perfil") === perfil}
            style={radioStyle}
          />
          {perfilLabels[perfil]}
        </label>
      </div>
    ))}
  </div>
);

export default PerfilRadioGroup;
